import React from 'react';
import classnames from 'classnames';

import styles from './Preloader.module.scss';

type Props = {
    fullScreen?: boolean;
};

const Preloader: React.FC<Props> = ({ fullScreen }: Props) => (
    <div
        className={classnames(
            styles.ldsEllipsis__container,
            fullScreen && styles.ldsEllipsis__container_fullScreen,
        )}
    >
        <div className={styles.ldsEllipsis}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
);

export default Preloader;
